const lapseModel = {
    rson:{
      type:"select",
      title: "What was the lapse/incident?",
      validators: ["required"],
      options: [{value:"Ins Lapse?NotReqrd",name:"No Vehicle Hence No Insurance Required"},{value:"Ins Lapse?DWOI",name:"Driving without Insurance"},{value:"Ins Lapse?LicSusp",name:"Ins. Cancelled due to License Suspension"},{value:"Ins Lapse?NonDiscl",name:"Ins. Cancelled due to Non Disclosure of Information"},{value:"Ins Lapse?MatMisrep",name:"Material Misrepresentation"},{value:"Ins Lapse?NonPay",name:"Ins. Cancelled due to Defaulting Policy Payment"},{value:"Ins Lapse?OtherLapse",name:"Other"},{value:"Lic Susp?Alcohol",name:"Alcohol related license suspension"},{value:"Lic Susp?Crim",name:"Criminal related (Non Alcohol) License Suspension"},{value:"Lic Susp?Points",name:"Too many convictions"},{value:"Lic Susp?Fine",name:"Suspension due to non payment of fines"},{value:"Lic Susp?OtherSusp",name:"Other - Administrative"},{value:"Lic Susp?OtherNonAdmin",name:"Other - Non-administrative"},{value:"Ins Fraud?",name:"Insurance Fraud"},{value:"Mat Misrep?",name:"Insurance Material Misrepresentation"}],
      value:"" //Ins Lapse?MatMisrep
    },
    indt:{
      type:"date",
      validators: ["required"],
      title: "Lapse/Incident date",
      value:"" //20210101
    }
} 

export default lapseModel;